import { FunctionComponent } from 'react';
import { EducatorForm } from '../EducatorForm';
import { DefaultForm } from '../DefaultForm';
import { CademyError } from '@shared/domain-shared';

export type BookerFormProps = {
    error: CademyError | null;
    disabled?: boolean;
    formId: string | null;
};

const disabledFields = ['system_email'];

export const BookerForm: FunctionComponent<BookerFormProps> = ({ formId, error, disabled }) => {
    if (!formId) {
        return <DefaultForm disabled={disabled} disabledFields={disabledFields} error={error} />;
    }
    return (
        <EducatorForm
            disabled={disabled}
            disabledFields={disabledFields}
            formId={formId}
            error={error}
        />
    );
};
